import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import InvertColors from '../../components/InvertColors';

const InvertPage: React.FC = () => (
  <ToolLayout
    title="Invert Image Colors Online Free | AllTools"
    description="Invert image colors instantly. Full invert, channel-selective, and hue invert modes. Free online tool."
    canonicalPath="/invert-colors"
  >
    <InvertColors />
  </ToolLayout>
);

export default InvertPage;
